import Home from '../components/Home';

export default function HomeContainer() {
  return (
    <div>
      <Home />
    </div>
  );
}